import { useMutation } from 'react-query';
import { useParams } from 'react-router-dom';
import { usePageType } from '~/hooks';
import { 
  assignProjectToInvestor, 
  assignPortfolioToInvestor, 
  updateInvestorInProjectQueue, 
  updateInvestorInPortfolioQueue, 
  AssignToInvestorParams, 
  UpdateInvestorQueueParams 
} from '~/api/adminInvestorInvitations';

const useAddOrUpdateInvestor = (params = {}) => {
  const pageType = usePageType();
  const { id } = useParams<{ id: string }>();
  
  return useMutation({
    mutationFn: async ( { isEditing, data }: { isEditing: boolean, data: any }) => {
      if (pageType === 'project') {
        return isEditing
          ? updateInvestorInProjectQueue(id, data as UpdateInvestorQueueParams)
          : assignProjectToInvestor(id, data as AssignToInvestorParams);
      } else if (pageType === 'portfolio') {
        return isEditing
          ? updateInvestorInPortfolioQueue(id, data as UpdateInvestorQueueParams)
          : assignPortfolioToInvestor(id, data as AssignToInvestorParams);
      }
    },
    ...params
  });
};

export default useAddOrUpdateInvestor;